module.exports = __webpack_public_path__ + "img/129.6fab0e23.jpg";